import {animate, style, transition, trigger} from "@angular/animations";

export const getAnimationTrigger = (ms: number, name: string = 'showHideTrigger') => {
    return trigger(name, [
        transition(':enter', [
            style({ opacity: 0 }),
            animate(`${ms}ms`, style({ opacity: 1 })),
        ]),
        transition(':leave', [
            animate(`${ms}ms`, style({ opacity: 0 }))
        ])
    ])
}
